import Vue from 'vue';
import ProgressBar from 'vuejs-progress-bar';

Vue.use(ProgressBar);
